import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVolumeOff, faBolt, faLeaf, faScrewdriverWrench, faCircleNotch } from '@fortawesome/free-solid-svg-icons';

const IconList = () => {
  const [iconSize, setIconSize] = useState('');

  const getIconSize = () => {
    const screenWidth = window.innerWidth;

    if (screenWidth <= 768) {
      return '1.5rem';
    } else if (screenWidth <= 1200) {
      return '2rem';
    } else if (screenWidth <= 1440) {
      return '2.5rem';
    } else {
      return '2.5rem';
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIconSize(getIconSize());
    };

    // Attach the event listener
    window.addEventListener('resize', handleResize);

    // Initial icon size
    setIconSize(getIconSize());

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const iconStyle = {
    color: 'white',
    fontSize: iconSize,
  };

  const containerStyle = {
    display: 'flex',
    justifyContent: 'center',
    gap: '8px', // Adjust the gap as needed
    borderRadius: '10px',
    padding: '20px',
    background: 'none',
    flexWrap: 'wrap',
  };

  return (
    <div className="icon-description" style={containerStyle}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '8px', textAlign: 'center', flex: '1' }}>
        <FontAwesomeIcon icon={faCircleNotch} style={iconStyle} />
        <p style={{ color: 'white', margin: '8px' }}>Zero<br />Friction</p>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '8px', textAlign: 'center', flex: '1' }}>
        <FontAwesomeIcon icon={faVolumeOff} style={iconStyle} />
        <p style={{ color: 'white', margin: '8px' }}>Quieter<br />Operation</p>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '8px', textAlign: 'center', flex: '1' }}>
        <FontAwesomeIcon icon={faBolt} style={iconStyle} />
        <p style={{ color: 'white', margin: '8px' }}>Higher<br />Speeds</p>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '8px', textAlign: 'center', flex: '1' }}>
        <FontAwesomeIcon icon={faScrewdriverWrench} style={iconStyle} />
        <p style={{ color: 'white', margin: '8px' }}>Lower<br />Maintenance</p>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '8px', textAlign: 'center', flex: '1' }}>
        <FontAwesomeIcon icon={faLeaf} style={iconStyle} />
        <p style={{ color: 'white', margin: '8px' }}>Higher<br />Efficiency</p>
      </div>
    </div>
  );
}

export default IconList;
